import { render } from "./FeedItem.vue?vue&type=template&id=8032974e&scoped=true"
import script from "./FeedItem.vue?vue&type=script&lang=js"
export * from "./FeedItem.vue?vue&type=script&lang=js"

import "./FeedItem.vue?vue&type=style&index=0&id=8032974e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8032974e"]])

export default __exports__